import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IVideoTutorial } from "../../../Pages/VideoPage/IVideoTutorial";

export const EditVideoTutorialSlice = createSlice({
    name: "EditVideoTutorialSlice",
    initialState: {} as IReduxState<IVideoTutorial>,
    reducers: {
        editVideoTutorial: (state, action) => {
            state.isLoading = true;
        },
        successeditVideoTutorial: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        failureeditVideoTutorial: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        clearEditVideoTutorialResponse: (state) => {
            state.data = {};
        },
    },
});

export const {
    failureeditVideoTutorial,
    editVideoTutorial,
    successeditVideoTutorial,
    clearEditVideoTutorialResponse,
} = EditVideoTutorialSlice.actions;

export default EditVideoTutorialSlice.reducer;
